import gql from 'graphql-tag';
import { surfaceDetailsFragment } from 'graphql/surface/fragments/surface-fragment';

export const userDetailsFragment = gql`
  fragment userDetails on User {
    id
    fullName
    firstName
    lastName
    email
    emailVerified
    avatar
  }
`;

export const notificationDetailsFragment = gql`
  fragment notificationDetails on Notification {
    id
    type
    message
    status
    sender {
      avatar
      firstName
      lastName
      fullName
    }
    surface {
      ...surfaceDetails
    }
  }
  ${surfaceDetailsFragment}
`;
